<template>
  <div class="wrapper">
     <!-- Modal Loading -->
    <v-dialog persistent max-width="300" v-model="blockScreen">
      <v-card class="px-3 py-5 text-center">
        <div class="text-center pb-5">
          <span class="title font-weight-bold">Aguarde, estamos processando os dados...</span>
        </div>
        <v-progress-circular :size="70" :width="7" class="checkin-text" indeterminate></v-progress-circular>
      </v-card>
    </v-dialog>
    <!-- alerta -->
    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <div class="register-card">
      <div class="back">
        <v-btn icon small @click="goBack()">
          <v-icon class="secondary-color text--darken-1">arrow_back</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </div>
      <div class="register-card-header">
        <img
          :src="require(`@/assets/logos/usecargoazul.png`)"
          alt="pickndrive"
          style="width: 240px; margin-bottom: 12%; margin-top: 5%;"
        />
      </div>
      <div class="text-center text--darken-1 pb-3" v-if="this.disableAll">
        CNH anexada
        <v-icon color="success">mdi-check</v-icon>
      </div>

      <div v-else class="justify-center text-center pb-3">
        <v-btn text class="text--darken-1" v-on:click="showCnhModal = true"
          >Importar dados da CNH</v-btn
        >
        <v-icon>mdi-camera</v-icon>
      </div>

      <div class="text-center pb-3">
        <span class="title font-weight-bold text--darken-1">Cadastro</span>
      </div>
      <form @submit.prevent="cadastro()">
        <div class="form-group text-left">
          <label class="subtitle" for="cep-input">CEP *</label>
          <input
            v-mask="'##.###-###'"
            type="text"
            class="form-control"
            v-model="cep"
            id="cep-input"
            placeholder="xx.xxx-xxx"
            required
            v-on:blur="obterCondominioPorCep()"
            minlength="8"
          />
        </div>
        <div class="form-group text-left">
          <label class="subtitle" for="client-input">Origem *</label>
          <v-tooltip bottom max-width="200">
            <template v-slot:activator="{ on }">
              <v-icon
                aria-hidden="true"
                small
                color="#9fd7f8"
                v-on="on"
                class="ml-2"
                >help</v-icon
              >
            </template>
            <span
              >Se o seu condomínio não está presente na lista, procure a sua
              administração.</span
            >
          </v-tooltip>
          <v-select
            :items="clients"
            v-model="clientSelected"
            :required="!clientSelected"
            item-text="name"
            item-value="id"
            label="Informe o cep antes da Origem"
            id="client-input"
            class="select-client"
            color="success"
            no-data-text="Nenhuma origem cadastrada"
            hide-details
            solo
            text
          ></v-select>
        </div>
        <div class="form-group text-left">
          <label class="subtitle" for="name-input">Nome *</label>
          <input
            :readonly="disableAll"
            type="text"
            class="form-control"
            v-model="name"
            id="nome-input"
            placeholder="Nome Completo"
            required
          />
        </div>
        <div class="form-group text-left">
          <label class="subtitle" for="email-input">E-mail *</label>
          <input
            type="email"
            class="form-control"
            v-model="email"
            id="email-input"
            aria-describedby="emailHelp"
            placeholder="seuemail@host.com.br"
            required
          />
        </div>
        <div class="form-group text-left">
          <label class="subtitle" for="email-input">Endereço *</label>
          <!-- <input
            type="text"
            class="form-control"
            v-model="endereco"
            id="endereco-input"
            aria-describedby="enderecoHelp"
            placeholder="Seu endereço"
            required
          /> -->
          <vue-google-autocomplete
            id="endereco-input"
            class="form-control"
            placeholder="Seu endereço"
            country="br"
            v-model="endereco.address_formatted"
            v-on:placechanged="setAddress"
          ></vue-google-autocomplete>
        </div>
        <div class="form-group text-center">
          <label for="complement-input">Complemento *</label>
          <input
            type="text"
            class="form-control"
            v-model="endereco.complement"
            id="complement-input"
            placeholder="Bloco xx, APTO yy"
            required
          />
        </div>
        <div class="form-group text-center">
          <label>Comprovante de residência</label>
          <v-tooltip bottom max-width="200">
            <template v-slot:activator="{ on }">
              <v-icon
                aria-hidden="true"
                small
                color="info"
                v-on="on"
                class="ml-2"
                >help</v-icon
              >
            </template>
            <span>
              O Comprovante de residência não é obrigatório, mas agiliza o
              processo de aprovação do seu cadastrado.
              <br />Docmuentos aceitos: Água, Luz e Telefone
            </span>
          </v-tooltip>
          <div class="custom-file">
            <input
              type="file"
              class="custom-file-input"
              @change="changeArchive('proof_of_address')"
            />
            <label class="subtitle custom-file-label">Anexar arquivo</label>
          </div>
        </div>
        <div class="px-2">
          <v-radio-group v-model="situacao" mandatory row>
            <v-radio class="subtitle" value="Morador">
              <template v-slot:label>
                <div class="pt-2">Morador</div>
              </template>
            </v-radio>
            <v-radio class="subtitle" value="Locatario">
              <template v-slot:label>
                <div class="pt-2">Locatário</div>
              </template>
            </v-radio>
          </v-radio-group>
        </div>
        <div class="form-group text-left">
          <label class="subtitle" for="cpf-input">CPF *</label>
          <input
            :readonly="disableAll"
            v-mask="'###.###.###-##'"
            type="text"
            class="form-control"
            v-model="cpf"
            id="cpf-input"
            placeholder="xxx.xxx.xxx-xx"
            required
            minlength="11"
          />
        </div>
        <div class="form-group text-left">
          <label class="subtitle" for="cnh-input">CNH</label>
          <input
            :readonly="disableAll"
            v-mask="'###########'"
            type="text"
            class="form-control"
            v-model="cnh.registro"
            id="cnh-input"
            placeholder="xxxxxxxxxxx"
          />
        </div>
        <div class="form-group text-left">
          <label class="subtitle" for="telefone-input">Telefone *</label>
          <input
            v-mask="'(##)#####-####'"
            type="text"
            class="form-control"
            v-model="telefone"
            id="telefone-input"
            placeholder="(DDD)Número"
            required
          />
        </div>

        <div class="form-group text-left">
          <label class="subtitle" for="nascimento-input"
            >Data de Nascimento</label
          >
          <input
            :readonly="disableAll"
            v-mask="'##/##/####'"
            type="text"
            class="form-control"
            v-model="dataNascimento"
            id="nascimento-input"
            placeholder="xx/xx/xxxx"
          />
        </div>

        <div class="form-group text-left">
          <label class="subtitle" for="invitation-code-input"
            >Código de Indicação</label
          >
          <input
            type="text"
            class="form-control"
            v-model="invitation_code"
            id="invitation-code-input"
          />
        </div>

        <div class="form-group text-left">
          <label class="subtitle" for="password-input">Senha *</label>
          <div class="input-group mb-3">
            <input
              :type="UI.passwordInputType"
              v-model="password"
              id="password-input"
              class="form-control"
              placeholder="Senha do usuário"
              aria-label="Senha do usuário"
              aria-describedby="basic-addon2"
              required
            />
            <div class="input-group-append">
              <span
                class="input-group-text change-visibility-span"
                id="basic-addon2"
                @click="showPassword"
                >{{ UI.passwordInputButton }}</span
              >
            </div>
          </div>
          <div class="mb-3">
            <input
              type="password"
              class="form-control"
              v-model="passwordCheck"
              id="password-input-check"
              placeholder="Confirme sua senha"
              required
            />
          </div>
        </div>

        <button
          :disabled="UI.isLoggingIn"
          type="submit"
          class="btn btn-block mt-5 white--text signUpButton"
        >
          {{ UI.isLoggingIn ? "Carregando" : "CADASTRE-SE" }}
        </button>
      </form>
    </div>

    <ModalCnh
      :show="showCnhModal"
      :internal="false"
      @success="atualizarDados($event)"
      @close="showCnhModal = false"
    ></ModalCnh>
  </div>
</template>

<script>
import AuthController from "../../controllers/AuthController.js";
import theming from "../../mixins/theming";
import ClientController from "../../controllers/ClientController.js";
import UserController from "../../controllers/UserController";
import MaskHelper from "../../helpers/MaskHelper";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import ModalCnh from "../user/ModalCnh";
import moment from "moment";

export default {
  components: {
    VueGoogleAutocomplete,
    ModalCnh,
  },
  mixins: [theming],
  data() {
    return {
      blockScreen:false,
      disableAll: false,
      clientController: new ClientController(this.$resource),
      userController: new UserController(this.$resource),
      name: null,
      email: null,
      password: null,
      endereco: {},
      situacao: null,
      cpf: null,
      telefone: null,
      dataNascimento: null,
      cnh: { registro: null },
      cep: null,
      passwordCheck: null,
      clients: [],
      clientSelected: null,
      invitation_code: null,
      UI: {
        isLoggingIn: false,
        passwordInputType: "password",
        passwordInputButton: "Mostrar",
      },
      snackbar: false,
      snackbarColor: "",
      snackbarText: "",
      files: [],
      showCnhModal: true,
    };
  },

  created() {
    this.authController = new AuthController(
      this.$resource,
      this.$router,
      this.$message
    );
  },

  methods: {
    atualizarDados(data) {
      this.alert("Cnh capturada com sucesso!", "success");
      this.cnh = data;
      this.name = data.nome;
      this.dataNascimento = moment(data.data_nascimento).format("DD/MM/YYYY");
      this.cpf = data.cpf;
      this.disableAll = true;
      this.showCnhModal = false;
    },

    setAddress(addressData, placeResultData, id) {
      let city = placeResultData.address_components.filter((cp) => {
        let type = cp.types.filter(
          (type) => type === "administrative_area_level_2"
        );
        if (type.length) return cp;
      });
      city = city[0].long_name;
      this.endereco.address_formatted = placeResultData.formatted_address;
      this.endereco.latitude = addressData.latitude;
      this.endereco.longitude = addressData.longitude;
      this.endereco.zip = addressData.postal_code
        ? addressData.postal_code.replace("-", "")
        : null;
      this.endereco.state = addressData.administrative_area_level_1;
      this.endereco.street = addressData.route;
      this.endereco.number = addressData.street_number;
      this.endereco.neighborhood = placeResultData.vicinity;
      this.endereco.city = city;
    },

    async getClients() {
      await this.clientController
        .getAllClientsPublic()
        .then((clients) => (this.clients = clients));
    },

    goBack() {
      this.$router.push("/");
    },
    gotoStatus() {
       this.$router.push({ name: "registerstatus" });
    },

    validate() {
      if (this.password != this.passwordCheck) throw "As senhas não coincidem.";
      if (!this.clientSelected) throw "Selecione uma origem";
    },

    showPassword() {
      let type = this.UI.passwordInputType;

      if (type === "password") {
        this.UI.passwordInputType = "text";
        this.UI.passwordInputButton = "Esconder";
        return;
      }

      this.UI.passwordInputButton = "Mostrar";
      this.UI.passwordInputType = "password";
    },

    async obterCondominioPorCep() {
      if (this.cep.length != 10) {
        return;
      }

      await this.clientController
        .getClientsByZipcode(this.cep)
        .then((clients) => (this.clients = clients));
    },

    alert(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },

    changeArchive(type) {
      this.files.push({
        type,
        data: event.target.files[0],
      });
      console.log(this.files);
    },

    async cadastro() {
      try {
        this.validate();

        let data = new FormData();

        let form = {
          name: this.name,
          email: this.email,
          password: this.password,
          clientsUser: this.clientSelected,
          situacao: this.situacao,
          endereco: this.endereco,
          hasForPasswordChange: false,
          profile_id: 2,
          cpf: this.cpf,
          phone: this.telefone,
          birthday: new Date("this.dataNascimento"),
          drive_license: this.cnh.registro,
          invitation_code: this.invitation_code,
          cnh: this.cnh,
        };

        data.append("form", JSON.stringify(form));

        this.files.forEach((element) => {
          data.append(element.type, element.data);
        });
        this.blockScreen = true;
        await this.userController
          .publicCreate(data)
          .then((res) => {
              this.gotoStatus();
          })
          .catch((e) => {
            this.blockScreen = false
            if (e.body.message) this.alert(e.body.message, "error");
            else
              this.alert(
                "Erro ao realizar cadastro, verifique seus dados e tente novamente.",
                "error"
              );
          });
      } catch (error) {
        this.alert(error, "error");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.signUpButton {
  background-color: var(--secondary-color) !important;
}

.secondary-color {
  color: var(--secondary-color) !important;
}

.subtitle {
  color: var(--secondary-color) !important;
  text-align: left;
}

.title {
  color: var(--secondary-color);
}

.select-client {
  background: white;
  border: 1px solid #016ea7;
  color: #016ea7;
}

a:hover {
  cursor: pointer;
}

.wrapper {
  position: fixed;
  width: 100vw;
  height: 100%;
  //background: url("../../assets/background-desktop.png");
  background-color: white;
  z-index: 2;
  background-size: cover;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  // justify-content: center;
  align-items: center;
  @media (max-width: 560px) {
    overflow: scroll;
    padding-bottom: 150px;
  }
}

input {
  background: white;
  border: 1px solid #016ea7;
  color: #016ea7;
}

.input-group-append .input-group-text.change-visibility-span {
  background: white;
  border: 1px solid #016ea7;
  color: #016ea7;
}

.wrapper .register-card {
  border-radius: 3px;
  width: 350px;
  position: relative;
  @media (max-width: 600px) {
    width: 80%;
  }
}

.register-card label {
  color: black;
}

.register-card .change-visibility-span:hover {
  cursor: pointer;
}

.register-card .register-card-header {
  display: flex;
  justify-content: center;
  img {
    width: 150px;
    height: 100%;
  }
}

footer,
footer p {
  margin-top: 20px;
  color: #993399;
  max-width: 400px;
  font-size: 9px;
  @media (max-width: 560px) {
    width: 80%;
  }
}

label {
  color: white;
}

.btn {
  color: white;
  background: var(--primary-color);
  font-weight: bold;
  &:disabled {
    background: rgba(100, 100, 100, 1);
    opacity: 1;
    color: white;
  }
}

input[type="checkbox"].form-control {
  width: fit-content;
  margin-right: 10px;
}

.back {
  display: flex;
  position: absolute;
  top: 10px;
}

a {
  color: rgb(159, 215, 248);
}
</style>
